import { Injectable } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';

/**
 * Custom OverlayContainer that attaches the overlay container to the correct DOM element.
 * If in fullscreen mode and the element with id 'fullscreen-element' exists, the container
 * is attached there; otherwise, it defaults to document.body.
 */
@Injectable()
export class CustomOverlayContainer extends OverlayContainer {
  /**
   * Creates the overlay container and attaches it to the proper element.
   * @override
   */
  protected override _createContainer(): void {
    const container = document.createElement('div');
    container.classList.add('cdk-overlay-container');
    this._containerElement = container;
    this.attachContainer();
  }

  /**
   * Attaches the overlay container to the correct element.
   * If in fullscreen mode and 'fullscreen-element' exists, attach to it;
   * otherwise, attach to document.body.
   */
  private attachContainer(): void {
    const fullscreenElement = document.getElementById('fullscreen-element');
    if (document.fullscreenElement && fullscreenElement) {
      if (this._containerElement.parentElement !== fullscreenElement) {
        fullscreenElement.appendChild(this._containerElement);
      }
    } else if (this._containerElement.parentElement !== document.body) {
      document.body.appendChild(this._containerElement);
    }
  }

  /**
   * Returns the overlay container element, ensuring it's attached to the proper element.
   * @override
   */
  override getContainerElement(): HTMLElement {
    if (!this._containerElement) {
      this._createContainer();
    }
    this.attachContainer();
    return this._containerElement;
  }
}
